import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NotificationMinute} from '../../../app/models/notification-minute';

// @ts-ignore
// @ts-ignore
@Component({
  selector: 'app-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss']
})
export class CustomDialogComponent{

    constructor(@Inject(MAT_DIALOG_DATA) public data: NotificationMinute,
        public dialogRef: MatDialogRef<CustomDialogComponent>
    )
    {
    }

}
